import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Fonts (Fontsource, OFL) — same pairing as llmr-website / antigravity.google:
// Google Sans Flex for Latin; IBM Plex Sans Thai (loopless / ไม่มีหัว) for Thai.
// Import thai-* subsets only so Plex has no Latin faces — one CSS stack then
// covers both locales; EN/TH must not look like different typefaces.
import '@fontsource-variable/google-sans-flex/wght.css';
import '@fontsource/ibm-plex-sans-thai/thai-400.css';
import '@fontsource/ibm-plex-sans-thai/thai-500.css';
import '@fontsource/ibm-plex-sans-thai/thai-600.css';
import '@fontsource/ibm-plex-sans-thai/thai-700.css';

import { App } from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
